import { GridCellParams, useGridApiContext } from "@mui/x-data-grid";
import { useIntl } from "react-intl";
import { formatEther } from "viem";
import { Grid, Typography } from "@mui/material";
import { Filter1, Filter2, Filter3, Filter4 } from "@mui/icons-material";

import { AddressLink } from "@dzambalaorg/mui-scanner";
import { IPonziLeaderboard, PonziLeaderboardRank } from "@framework/types";

// prettier-ignore
export const columnsCreator = (skip: number, formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.rank" }),
    sortable: false,
    renderCell: (params: GridCellParams) => {
      const apiRef = useGridApiContext();
      const row = params.row as IPonziLeaderboard;
      const index: number = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
      return (
        <Grid container direction="row" alignItems="center">
          {row.rank === PonziLeaderboardRank.GOLD ? <Filter1 /> : null}
          {row.rank === PonziLeaderboardRank.SILVER ? <Filter2 /> : null}
          {row.rank === PonziLeaderboardRank.BRONZE ? <Filter3 /> : null}
          {row.rank === PonziLeaderboardRank.BASIC ? <Filter4 /> : null}
          <Typography ml={1}>{index + skip + 1}</Typography>
        </Grid>
      );
    },
    flex: 0.5,
  },
  {
    field: "account",
    headerName: formatMessage({ id: "form.labels.account" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} />
      );
    },
    flex: 3,
    minWidth: 360
  },
  {
    field: "amount",
    headerName: formatMessage({ id: "form.labels.amount" }),
    sortable: false,
    valueFormatter: (value: string) => formatEther(BigInt(value)),
    flex: 1,
    minWidth: 100
  },
  {
    field: "name",
    headerName: formatMessage({ id: "form.labels.title" }),
    sortable: false,
    flex: 1,
    minWidth: 170
  }
]
